import clsx from 'clsx';

const labelClassNames = clsx('flex items-start gap-2 text-start text-caption1 text-black font-medium');
const isRequiredClassNames = clsx('ps-2 -mb-0.5 mt-0.5 text-red-500');
var styles = {
    labelClassNames,
    isRequiredClassNames,
};

export { styles as default };
